import { motion } from "framer-motion";
import { useLanguage } from "@/lang";
import { SectionHeading } from "./SectionHeading";

export const Press = () => {
  const { copy } = useLanguage();

  return (
  <section id="presse" data-testid="press-section" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
    <SectionHeading {...copy.headings.profil} />

    <div className="space-y-20 md:space-y-28">
      {copy.statements.map((item, i) => (
        <motion.blockquote
          key={i}
          data-testid={`press-quote-${i}`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center max-w-4xl mx-auto"
        >
          <p className="font-display italic text-2xl md:text-4xl lg:text-5xl leading-snug tracking-tight text-zinc-200">
            {item.text}
          </p>
          <cite className="block mt-6 not-italic text-xs uppercase tracking-[0.3em] text-zinc-500">
            — {item.source}
          </cite>
        </motion.blockquote>
      ))}
    </div>
  </section>
  );
};
